import { render } from "./NodrizaTableConfirmationButton.vue?vue&type=template&id=a7ec4528"
import script from "./NodrizaTableConfirmationButton.vue?vue&type=script&lang=js"
export * from "./NodrizaTableConfirmationButton.vue?vue&type=script&lang=js"

import "./NodrizaTableConfirmationButton.vue?vue&type=style&index=0&id=a7ec4528&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__